import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const AdminRedirectHandler: React.FC = () => {
  const history = useHistory();
  const { instance } = useMsal();

  useEffect(() => {
    // Consume the /admin/login/callback#code=... fragment and finish login
    instance.handleRedirectPromise()
      .then(() => {
        const saved = sessionStorage.getItem("msal.redirectStartPage");
        history.replace(saved || "/admin");
      })
      .catch(() => {
        // If something goes wrong, just send them to /admin
        history.replace("/admin");
      });
  }, [history, instance]);

  return <div>Signing you in...</div>;
};

export default AdminRedirectHandler;
